var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Status/info-circle/4px colour mask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0.7675 C14.3228266,0.7675 18.2325,4.67717342 18.2325,9.5 C18.2325,14.3228266 14.3228266,18.2325 9.5,18.2325 C4.67717342,18.2325 0.7675,14.3228266 0.7675,9.5 C0.7675,4.67717342 4.67717342,0.7675 9.5,0.7675 Z M9.5,7.5575 L8.625,7.5575 C8.27706061,7.5575 7.995,7.83956061 7.995,8.1875 C7.995,8.53543939 8.27706061,8.8175 8.625,8.8175 L8.87,8.8175 L8.8695,12.8065 L8.625,12.8075 C8.27706061,12.8075 7.995,13.0895606 7.995,13.4375 C7.995,13.7854394 8.27706061,14.0675 8.625,14.0675 L10.375,14.0675 C10.7229394,14.0675 11.005,13.7854394 11.005,13.4375 C11.005,13.0895606 10.7229394,12.8075 10.375,12.8075 L10.1295,12.8065 L10.13,8.1875 C10.13,7.83956061 9.84793939,7.5575 9.5,7.5575 Z M9.28125,4.823125 C8.81249832,4.823125 8.4325,5.20312332 8.4325,5.671875 C8.4325,6.14062668 8.81249832,6.520625 9.28125,6.520625 C9.75000168,6.520625 10.13,6.14062668 10.13,5.671875 C10.13,5.20312332 9.75000168,4.823125 9.28125,4.823125 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login_username",
    transform: "translate(-1216.000000, -328.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Status/info-circle/4px-colour-mask",
    transform: "translate(1216.000000, 328.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colours/Grey-6-|-#999999",
    mask: "url(#mask-2)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, -1.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    mask: "url(#mask-2)",
    x: -1,
    y: -1,
    width: 21,
    height: 21
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTip);
export default __webpack_public_path__ + "static/media/tool_tip.ca12309be8216df6b51c31e271d12d22.svg";
export { ForwardRef as ReactComponent };